module.exports = __webpack_public_path__ + "img/brain.e7be6e50.svg";